import {
  BigIconButton,
  TooltipContent,
  TooltipRoot,
  TooltipTrigger,
} from '@socialchorus/shared-ui-components';
import { forwardRef } from 'react';
import { usePatronSelector } from '../../../../common/use-patron-selector';
import {
  AssistantIntegration,
  getIntegration,
} from '../../../../models/assistant/selectors';
import { LinkNavigation } from '@socialchorus/shared-ui-components/dist/components/Link';

export interface ShortcutButtonProps {
  id: AssistantIntegration['id'];
  label: string;
  iconSrc?: string;
  href?: string | LinkNavigation;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  target?: string;
  rel?: string;
  description?: string;
}

const ShortcutButton = forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  ShortcutButtonProps
>(
  (
    { id, iconSrc, label, href, onClick, className, target, rel, description },
    ref
  ) => {
    const integration = usePatronSelector((state) =>
      getIntegration(state, { integrationId: id })
    );

    return (
      <TooltipRoot>
        <TooltipTrigger asChild>
          <BigIconButton
            role="link"
            imgSrc={iconSrc}
            label={label}
            href={href}
            onClick={onClick}
            className={className}
            target={target}
            rel={rel}
            ref={ref}
          />
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          description={integration?.subject.description || description}
        />
      </TooltipRoot>
    );
  }
);

ShortcutButton.displayName = 'ShortcutButton';

export default ShortcutButton;
